// extracted by mini-css-extract-plugin
export var billingAddress = "_qi-g";
export var contactInfo = "_qi-d";
export var customerInfoContainer = "_qi-c";
export var customerInfoContainerMobile = "_qi-h";
export var customerInfoRow = "_qi-a";
export var customerInfoSection = "_qi-b";
export var fullWidthDividerMobile = "_qi-i";
export var imageContainer = "_qi-1";
export var paymentMethod = "_qi-e";
export var priceText = "_qi-6";
export var priceTextMobile = "_qi-7";
export var product = "_qi-0";
export var productImage = "_qi-2";
export var productInfo = "_qi-4";
export var productMobile = "_qi-9";
export var productTitle = "_qi-8";
export var quantityBadge = "_qi-3";
export var quantityText = "_qi-5";
export var shippingAddress = "_qi-f";